<template>
	<div
		class="nav company"
		:class="isOpen && 'is-open'"
		:style="dropdownStyles"
		data-id="company"
	>
		<button
			id="companyselected"
			@click="toogleList"
			class="company__btn"
			:title="selectedCompanyHoverText"
		>
			<span class="company__icon">
				<i class="icon icon-company" />
			</span>
			<span class="company__name" data-id="company-name">{{
				selectedCompanyName
			}}</span>
			<span
				class="company__number"
				data-id="company-number"
				v-if="selectedCompanyNumber"
				>{{ `(${selectedCompanyNumber})` }}</span
			>
			<span class="company__expand-icon">
				<i class="icon icon-arrow_down_filled" />
			</span>
		</button>
		<ul id="companylist" class="company__menu" v-if="isOpen">
			<li
				:class="[
					'company__menu-item',
					company.id == activeCompanyId ? 'is-active' : ''
				]"
				@click="changeCompany(company)"
				v-for="company in companies.items"
				:key="company.id"
				:id="`company_${company.id}`"
			>
				<a
					:href="`/?cid=${company.id}`"
					class="company__menu-item-link"
					tabindex="0"
					@click="onLinkClick"
				>
					<span
						class="company__color-badge"
						:style="itemStyle(company)"
					/>
					<span class="company__menu-link">
						{{ company.companyName }}
						{{ `(${company.companyNumber})` }}
					</span>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import getCompanyId from '@/composables/get-companyid';
import setCompanyId from '@/composables/set-companyid';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'VueCompanySelector',
	data() {
		return {
			isOpen: false,
			activeCompanyId: 0
		};
	},
	async created() {
		this.activeCompanyId = getCompanyId(this.$route);
		await this.getCompaniesAction(this.activeCompanyId);
	},
	mounted() {
		document.addEventListener('click', this.clickHandler);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.clickHandler);
	},
	computed: {
		...mapGetters('user', ['companiesResults']),
		companies() {
			let companiesResults = {};

			if (this.companiesResults !== undefined) {
				companiesResults = this.companiesResults;
			}

			return companiesResults;
		},
		selectedCompany() {
			return (
				this.companies.items &&
				this.companies.items.find(
					item => item.id == this.activeCompanyId
				)
			);
		},
		selectedCompanyName() {
			const defaultCompany = this.selectedCompany;
			if (defaultCompany) {
				return defaultCompany.companyName;
			}
			return '';
		},
		selectedCompanyNumber() {
			const defaultCompany = this.selectedCompany;
			if (defaultCompany) {
				return defaultCompany.companyNumber;
			}
			return '';
		},
		selectedCompanyHoverText() {
			const defaultCompany = this.selectedCompany;
			if (defaultCompany) {
				return `${defaultCompany.companyName} (${defaultCompany.companyNumber})`;
			}
			return '';
		},
		dropdownStyles() {
			return [
				{
					'--company-default-color': this.getCompanyColor(),
					'--company-default-color--fg': this.getFontColor()
				}
			];
		}
	},
	methods: {
		...mapActions('user', ['getCompaniesAction', 'clearStateAction']),
		clickHandler(event) {
			const { target } = event;
			const { $el } = this;
			if (!$el.contains(target)) {
				this.isOpen = false;
			}
		},
		toogleList() {
			this.isOpen = !this.isOpen;
		},
		getCompanyColor(company) {
			company = company || this.selectedCompany;
			if (company && company.companyColor) {
				return `#${company.companyColor}`;
			}
			return '#ffffff';
		},
		getFontColor(company) {
			company = company || this.selectedCompany;
			if (company && company.fontColor) {
				return company.fontColor;
			}
			return '#000000';
		},
		changeCompany(company) {
			this.toogleList();
			if (this.activeCompanyId != company.id) {
				this.activeCompanyId = company.id;
				this.clearStateAction();
				setCompanyId(company.id);
			}
		},
		itemStyle(company) {
			return [{ backgroundColor: this.getCompanyColor(company) }];
		},
		onLinkClick(e) {
			//don't let the link navigate because we need changeCompany to be called
			e.preventDefault();
		}
	}
};
</script>

<style lang="scss" scoped>
@include scrollbar('borderless');

/**
    * [Description]
    *
    * Company Selector
    * Can use SCSS variables = TRUE
*/

// UI/UX NOTE: Please revisited when the dark theme design is finished
.company {
	@include header-menu-item('.company');

	&.is-open &__btn {
		background: none;
		color: var(--bg-2-fg-3);

		@include mq($from: md-l) {
			&:hover {
				background: var(--menu-list-bg-hover);
				color: var(--menu-list-fg-hover);
			}
		}
	}

	&:hover &__btn {
		@include mq($from: md-l) {
			background: none;
			color: var(--bg-2-fg-3);
		}
	}

	&__btn {
		background: var(--company-default-color);
		color: var(--company-default-color--fg);
		border-radius: 0;
		@include header-focus-styles;
	}

	&__number {
		margin-left: $gutter-xs;
		margin-right: $gutter-sm;
	}

	&__icon {
		margin-right: $gutter-sm;
		font-size: 24px;
	}

	&__menu {
		max-height: 500px;
		overflow: auto;
	}

	&__menu-item {
		display: flex;
		align-items: center;
	}

	&__color-badge {
		display: inline-block;
		min-width: 16px;
		width: 16px;
		height: 16px;
		margin-right: $gutter-md;
		border-radius: $border-radius;
		border: 1px solid var(--neutral-1);
	}

	&__menu-item-link {
		@include header-focus-styles;
	}
}
</style>
